import { PopUp } from "../types/pop-up";

export const popUpFallback: PopUp = {
  styles: {
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
  
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '99999999'
  },
  backdrop: {
    styles: {
      position: 'fixed',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',

      backgroundColor: '#07344BE5',
      opacity: '50%'
    }
  },
  popUpContent: {
    styles: {
      position: 'fixed',
      // maxWidth: '70%',
      // maxHeight: '85%',
      height: '100%',
      width: '100%',
      
      display: 'flex',
      // overflow: 'hidden',
    }
  }
};